import $ from 'jquery';
import I18n from 'i18n';

$(document).on('fileUpload-sizeChange', '.js-validate-max-size', (e) => {
  const MAX_SIZE = 95 * 1024 ** 2; // 95 MB in bytes
  const message = I18n.t('card.form.total_upload_size_error');
  const form = e.currentTarget;
  const fields = form.querySelectorAll('xs-file-upload');
  const validator = form.ClientSideValidations;
  let total = 0;

  fields.forEach((el) => { total += el.attachedSize; });

  fields.forEach((el) => {
    if (total > MAX_SIZE && el.attachedSize) validator.addError($(el), message);
    else validator.removeError($(el), message);
  });
})
  .on('ajax:error', '.js-validate-max-size', (e) => {
    if (e.detail[2].status === 413) {
      e.currentTarget.querySelector('.invalid xs-file-upload')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  });
